import React, { useState } from 'react';
import "./styles.css";

/* global gtag */

const pricingPlans = [
	{
		title: "Free",
		price: {
			monthly: "₹ 0",
			annual: "₹ 0"
		},
		duration: {
			monthly: "/month",
			annual: "/month"
		},
		highlight: false,
		description: "Perfect for getting started with AI-powered learning",
		features: [
			"Access to 2 AI teachers",
			"50 practice questions per month",
			"Basic progress tracking",
			"Community support",
		],
		notIncluded: [
			"Limited to 2 subjects",
			"No detailed analytics",
			"No personalized study plans"
		],
		ctaText: "Start Free",
		ctaLink: "#",
		badge: null
	},
	{
		title: "Student Pro",
		price: {
			monthly: "₹ 1500",
			annual: "₹ 1200"
		},
		duration: {
			monthly: "/month",
			annual: "/month"
		},
		originalPrice: {
			monthly: "₹ 3000",
			annual: "₹ 3000"
		},
		highlight: true,
		badge: "Most Popular",
		discountBadge: {
			monthly: "50% OFF",
			annual: "60% OFF"
		},
		description: "Unlimited learning with personalized AI guidance",
		features: [
			"Access to 5+ AI teachers",
			"Unlimited practice questions",
			"Detailed progress analytics",
			"Priority support",
			"Performance predictions",
			"Study streak tracking",
		],
		notIncluded: [],
		ctaText: "Coming Soon",
		// trialNote: "7-day free trial · Cancel anytime"
	},
	{
		title: "Enterprise",
		price: {
			monthly: "Custom",
			annual: "Custom"
		},
		duration: {
			monthly: "pricing",
			annual: "pricing"
		},
		highlight: false,
		description: "Complete assessment automation for institutions",
		features: [
			"Automated question paper generation",
			"AI-powered grading system",
			"Institutional analytics dashboard",
			"Bulk student management",
			"CBSE curriculum alignment",
			"Custom branding options",
			"Dedicated account manager",
			"Training & onboarding",
			"24/7 priority support"
		],
		notIncluded: [],
		ctaText: "Contact Sales",
		ctaLink: "#",
		badge: null
	}
];

const PricingPlans = () => {
	const [isAnnual, setIsAnnual] = useState(true);



	const scrollToContact = () => {
		const contactSection = document.getElementById("contact-form");
		if (contactSection) {
			contactSection.scrollIntoView({ behavior: 'smooth' });
		} else {
			// If not found on current page, redirect to education page with contact hash
			window.location.href = '/edu#contact-form';
		}
	};

	const handleContactSalesClick = () => {
		if (typeof gtag !== 'undefined') {
			gtag('event', 'ads_conversion_Contact_Us_1', {
				'event_callback': () => {
					scrollToContact();
				},
				'event_timeout': 2000,
			});
		} else {
			// gtag is not available, directly goes for the action
			scrollToContact();
		}
	};

	return (
		<section className="pricing-section">
			<div className="container">
				<div className="pricing-header">
					<div className="section-badge">Pricing Plans</div>
					<h2 className="section-title">Choose Your Learning Journey</h2>
					<p className="section-subtitle">
						Flexible options for individual learners and institutions of all sizes
					</p>
				</div>

				<div className="pricing-toggle-container">
					<div className="billing-options">
						<span
							className={!isAnnual ? "active" : ""}
							onClick={() => setIsAnnual(false)}
						>
							Monthly
						</span>
						<span
							className={isAnnual ? "active" : ""}
							onClick={() => setIsAnnual(true)}
						>
							Annual
						</span>
					</div>
				</div>

				<div className="pricing-plans-grid">
					{pricingPlans.map((plan, index) => (
						<div key={index} className={`pricing-card ${plan.highlight ? "highlighted" : ""}`}>
							{plan.badge && <span className="pricing-badge">{plan.badge}</span>}
							<h3 className="pricing-plan-title">
								{plan.title}
								{plan.title === "Student Pro" && (
									<span className="learning-discount-badge" style={{ marginLeft: '6px' }}>
										{isAnnual ? plan.discountBadge.annual : plan.discountBadge.monthly}
									</span>
								)}
							</h3>
							<div className="pricing-amount">
								{plan.title === "Student Pro" ? (
									<>
										{(isAnnual ? plan.originalPrice?.annual : plan.originalPrice?.monthly) && (
											<span className="original-price">
												{isAnnual ? `₹ ${parseInt(plan.originalPrice.annual.replace('₹ ', ''))} /month` : `${plan.originalPrice.monthly}/month`}
											</span>
										)}
										<span className="price">
											{isAnnual ? `₹ ${parseInt(plan.price.annual.replace('₹ ', ''))}` : plan.price.monthly}
											<span className="duration">{isAnnual ? '/month' : plan.duration.monthly}</span>
										</span>
									</>
								) : (
									<>
										<span className="price">
											{isAnnual ? plan.price.annual : plan.price.monthly}
											<span className="duration">{isAnnual ? plan.duration.annual : plan.duration.monthly}</span>
										</span>
									</>
								)}
							</div>
							<p className="pricing-description">{plan.description}</p>

							<ul className="pricing-features">
								{plan.features.map((feature, i) => (
									<li key={i} className="feature-included">
										<svg className="check-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
											<polyline points="20 6 9 17 4 12"></polyline>
										</svg>
										{feature}
									</li>
								))}
							</ul>

							{plan.notIncluded.length > 0 && (
								<ul className="pricing-features not-included-features">
									{plan.notIncluded.map((item, i) => (
										<li key={i} className="feature-not-included">
											<svg className="cross-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
												<line x1="18" y1="6" x2="6" y2="18"></line>
												<line x1="6" y1="6" x2="18" y2="18"></line>
											</svg>
											{item}
										</li>
									))}
								</ul>
							)}

							<button 
								className={`pricing-cta-button ${plan.highlight ? "primary" : ""}`} 
								onClick={
									plan.title === "Free" 
										? () => window.open("https://app.aichanakya.in/", "_blank")
										: plan.title === "Student Pro" 
											? scrollToContact
											: plan.title === "Enterprise" 
												? handleContactSalesClick
												: undefined
								}
							>
								{plan.ctaText}
							</button>

							{plan.trialNote && <p className="pricing-trial-note">{plan.trialNote}</p>}
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default PricingPlans;
